import styles from './styles.module.css';

function NoResultFound() {
  return <div className={styles.host}>検索結果がありません</div>;
}

export default NoResultFound;
